import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { midas } from '@resurs/midas'
import { Table } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import styles from './styles.module.scss'
import { TransactionTypes } from '../../../../util/transactionConstants'

const TransactionLogEntry = ({ entry, index }) => {
  const translateEntryType = entryType => {
    switch (entryType) {
      case TransactionTypes.DEBIT:
        return getText('transactions.transaction.history.debit')
      default:
        return getText('transactions.transaction.history.credit')
    }
  }
  const headers = () => (
    <tr>
      <th className={midas.textLeft} style={{ width: '190px' }}>
        {getText('transactions.headers.date')}
      </th>
      <th className={midas.textLeft} style={{ width: '250px' }}>
        {getText('transactions.headers.createdBy')}
      </th>
      <th className={midas.textLeft} style={{ width: '160px' }}>
        {getText('transactions.headers.totalAmount')}
      </th>
    </tr>
  )

  const getCreatedByText = () => {
    if (entry.entryType === TransactionTypes.DEBIT) {
      return getText('transactions.transaction.history.terminal')
    }
    if (entry.createdBy === 'Unknown') {
      return getText('transactions.transaction.history.createdByDefault')
    }
    return entry.createdBy
  }

  const entryRow = () => {
    return (
      <tr className={styles.entryRow} key={index}>
        <td>{`${moment(entry.creditDate).format('L LT')}`}</td>
        <td>{getCreatedByText()}</td>
        <td>
          <NumberFormat
            value={entry.creditedAmountWithVat}
            displayType="text"
            thousandSeparator=" "
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            renderText={val => getText('default.currency', val)}
          />
        </td>
      </tr>
    )
  }
  return (
    <div>
      <h5
        style={{
          margin: '2rem 1rem',
          borderBottom: '0.1rem solid #dcddde',
          paddingBottom: '1rem',
        }}
        key="debit-label"
      >
        {translateEntryType(entry.entryType)}
      </h5>
      <Table disableHover key="debit-table">
        <thead>{headers()}</thead>
        <tbody>{entryRow()}</tbody>
      </Table>
    </div>
  )
}

TransactionLogEntry.propTypes = {
  entry: PropTypes.object,
  index: PropTypes.number.isRequired,
}

TransactionLogEntry.defaultProps = { entry: null }

export default TransactionLogEntry
